import React from "react"
import { snapshotExclude } from '../../variables/ComboValues'
import { SumTable, calcIncomeSum, calcTotalIncome, IncomeDetails } from "../Tree/Utils.js"

export const missing_err = (message) => {
    let i = Math.floor(Math.random(Date()) * 8386560)  // ID10000000 // // 
    return <h5 className="missing width3rd" key={i}>{message}</h5>
}

export const compare_list = (list, list2, labels) => {
    //console.log("compare_list list", list)
    //console.log("compare_list list2", list2)
    if (list === undefined || list === false )
        return missing_err("חסרה הגדרה של כל נתוני הרשימה הראשונה")
    if (list2 === undefined || list2 === false ){
        //missing_err("חסרה הגדרה של כל נתוני הרשימה השניה")
        return <div>{ missing_err("חסרה הגדרה של כל נתוני הרשימה השניה")}<br />{display_list(list, labels)} </div>
    }

    var resultList = Object.keys(list).map( item => {
        let label = labels[item] ? labels[item] : 'ללא שם שדה'
        if ((list[item] !== "" || list2[item] !== "") && !snapshotExclude.includes(item))
            return(<div key={item}  className="snap-item">
                        <span className="snap-label">{label}</span>
                        <span className="snap-item-data">{list[item]}</span>
                        <span className="snap-item-data2">{list[item] !== list2[item]? list2[item] : '"'}</span>
                    </div>)
        return "" 
    })
    if (resultList === "")
        return missing_err("כל השדות ריקים")
    return resultList
}

// display list with required list and signle parent supprt
// singleParent 3 - only woman 4 - only man 0 - both
export const display_list_r = (list, labels, required, singleParent) => {
    // console.log("display_list list =" ,list)
    if (list === undefined || list === false){
        console.log("display_list list = UNDEFINED")
        return ""
    }
    var resultList = Object.keys(list).map( item => {
        let label = labels[item] ? labels[item] : 'ללא שם שדה'
        if (snapshotExclude.includes(item))
            return ""
        if (required[item]){
            if (required[item] > 1 && required[item] !== singleParent) // ignore other parent when single
                return ""
            let bstyle = list[item] === "" ? 'missing' : null
            return(<div key={item} className={"snap-item " + bstyle}>
                        <span className="snap-label">{label}</span>
                        <span className="snap-item-data">{ list[item] !== "" ? list[item] : "חסר מידע" }</span>
                    </div>)
        } 
        if (list[item] !== ""){ // ignore empty && not required
            return(<div key={item} className="snap-item">
                        <span className="snap-label">{label}</span>
                        <span className="snap-item-data">{list[item]}</span>
                    </div>)
        }
        return "" //  all empty && not required
    })
    if (resultList === "")
        return missing_err("כל השדות ריקים")
    return resultList
}
// display list with required list for families in program (ignore single parent)
// singleParent 3 - only woman 4 - only man 0 - both
export const display_list_p = (list, labels, required) => {
    // console.log("display_list list =" ,list)
    if (list === undefined){
        console.log("display_list list = UNDEFINED")
        return ""
    }
    var resultList = Object.keys(list).map( item => {
        let label = labels[item] ? labels[item] : 'ללא שם שדה'
        if (snapshotExclude.includes(item))
            return ""
        if (required[item]){
            if (required[item] > 1) // TODO add inProgram test like above: && required[item] !== singleParent) // ignore other parent when single
                return ""
            var bstyle = list[item] === "" ? {background: '#cdcdcd'} : null
            return(<div key={item} style={bstyle} className="snap-item">
                        <span className="snap-label">{label}</span>
                        <span className="snap-item-data">{ list[item] !== "" ? list[item] : "חסר מידע" }</span>
                    </div>)
        } 
        if (list[item] !== ""){ // ignore empty && not required
            return(<div key={item} className="snap-item">
                        <span className="snap-label">{label}</span>
                        <span className="snap-item-data">{list[item]}</span>
                    </div>)
        }
        return "" //  all empty && not required
    })
    if (resultList === "")
        return missing_err("כל השדות ריקים")
    return resultList
}
export const display_list = (list, labels) => {
    // console.log("display_list list =" ,list)
    if (list === undefined){
        console.log("display_list list = UNDEFINED")
        return ""
    }
    let emptyL = 0
    Object.keys(list).map( item => emptyL += list[item] === "" ? 0 : 1  )
    if (emptyL === 0)
        return missing_err("כל השדות ריקים")
    var resultList = Object.keys(list).map( item => {
        let label = labels[item] ? labels[item] : 'ללא שם שדה'
        if (list[item] !== "" && !snapshotExclude.includes(item))
            return(<div key={item}  className="snap-item">
                        <span className="snap-label">{label}</span>
                        <span className="snap-item-data">{list[item]}</span>
                    </div>)
        return "" 
    })
    if (resultList === "")
        return missing_err("כל השדות ריקים")
    return resultList
}
export const compare_table = (table, table2, labels) => {
    //console.log("compare_tables table=", table)
    //console.log("compare_tables table2=", table2)
    if (table === undefined || table.length === 0)
        return missing_err("הטבלה ריקה") 

    let result = table.map((line, index) => {
        //console.log("compare table line2=", table2[index])
        return(<div key={index} className="snap-line">{compare_list(line, line, labels)}</div>)
    })
    // make sure table < table is handled correct
    // ADD: if table2 > table
    if (!result.length || result.every(item => item === "")) // arr.every(element => element === null)
        return missing_err("כל השדות ריקים")
    return result
}

// test if table empty for lables list
const test_empty_table = (table, labels) => {
    if (table === undefined || table === false || table.length === 0)
        return true

    if (table.length === 1){
        let res = ""
        Object.keys(labels).map(item => (item !== 'id' && table[0][item] !== undefined ? res = res + table[0][item] : ""))
        if (res === "")
            return true
    }
    return false
}
export const display_table = (table, labels) => {
    //console.log("display_table table=", table)
    if (test_empty_table(table, labels))
        return missing_err("הטבלה ריקה")

    let result = table.map((line, index) => {
        //console.log("display_table index="+index+"  line=", line)
        return (<div key={index} className="snap-line">{display_list(line, labels)}</div>)
    })
    //console.log("display_table result = ", result)
    if (result === undefined || !result.length)
        return missing_err("כל השדות ריקים")
    return result
}

// display table in single snapshot (no compare), with total
// skipL(abbel) - amount of columns to skip before display
// TODO: skipD not needed remove!
export const display_table2 = (table, labels, skipL, fieldSum) => {
    //console.log("display_table table=", table)
    if (test_empty_table(table, labels))
        return missing_err("הטבלה ריקה")

    let hdr = Object.values(labels).map((item, index) => index < skipL ? null : <td className="snap-table-cell" key={index}>{item}</td>)
    let result = table.map((line, index) => {
        //console.log("display_table index="+index+"  line=", line)
        let innerLine = Object.keys(labels).map((item, index2) => {
            if (index2 < skipL) return null // follow labels
            return (<td className="snap-table-cell" key={index2}>{line[item]}</td>) //// item in stead of line[item]
        })
        return (<tr key={index} className="snap-line">{innerLine}</tr>)
    })
    //console.log("display_table result = ", result)
    if (result === undefined || !result.length)
        return missing_err("כל השדות ריקים")
    let total = 0
    table.map((line, index) => total += line[fieldSum] === "" ? 0 : parseInt(line[fieldSum]))
    return (<table className="snap-table">
                <tbody>
                    <tr className="snap-table-header">{hdr}</tr>
                    {result}
                    {tfoot(total)}
                </tbody>
            </table>)
}

// display table in snapshot compare
// skipL(abbel) - amount of columns to skip before display
// if line in table not in table2 - mark it
export const display_table_cmp = (table, labels, skipL, table2, fieldSum) => {
    //console.log("display_table table=", table)
    if (table === undefined || table === false || table.length === 0)
        return missing_err("הטבלה ריקה")

    if (table.length === 1){
        let res = ""
        Object.keys(labels).map((item) => res = table[0][item] !== undefined ? res + table[0][item] : res)
        if (res === "")
            missing_err("הטבלה ריקה")
    }
    let found = [];
    // look for lines in table 2
    found = compare2tables(table, table2)

    let hdr = Object.values(labels).map((item, index) => index < skipL ? null : <td className="snap-table-cell" key={index}>{item}</td>)
    let result = table.map((line, index) => {
        //console.log("display_table index="+index+"  line=", line)
        let innerLine = Object.keys(labels).map((item, index2) => { //labels line[item]
            if (index2 < skipL) return null // follow labels
            return (<td className={"snap-table-cell " + (!found[index] ? 'missing' : "")} key = {index2}> {line[item]} </td>)
        })
        return (<tr key={index} className="snap-line">{innerLine}</tr>)
    })
    //console.log("display_table result = ", result)
    if (result === undefined || !result.length)
        return missing_err("כל השדות ריקים")
    let total = 0
    table.map((line) => total += line[fieldSum] === "" ? 0 : parseInt(line[fieldSum]))
    return (<table className="snap-table">
                <tbody>
                    <tr className="snap-table-header">{hdr}</tr>
                    {result}
                    {tfoot( total)}
                </tbody>
            </table>)
}
const tfoot = (total) => <tr className="snap-table-header"><td>סך הכל</td><td >{total}</td></tr>

export const compare_tables_new = (snap, dfrom, dto, tableId, labels, skipL, fieldSum) => {

    if (test_empty_table(dfrom['acf'][tableId], labels) && test_empty_table(dto['acf'][tableId], labels))
        return <h5 className="missing width3rd">שתי הטבלאות ({snap['from']}, {snap['to']}) ריקות</h5>

    return (
        <React.Fragment>
            <h5>{snap['from']}</h5>
            <ul><li>שורות מסומנות עודכנו או נמחקו בהמשך</li></ul>
            {display_table_cmp(dfrom['acf'][tableId], labels, skipL, dto['acf'][tableId], fieldSum)}
            <hr />
            <h5>{snap['to']}</h5>
            <ul><li>שורות מסומנות עודכנו או נוספו</li></ul>
            {display_table_cmp(dto['acf'][tableId], labels, skipL, dfrom['acf'][tableId], fieldSum)}
        </React.Fragment>
    )
}
// find lines in t1 that are in t2 too
// return array of table line numbers w/booleans
const compare2tables = (t1, t2) => {
    //    Object.keys(labels).map((item, index) => res = res + table[0][item])

    // generate a "word" foreach line in t1
    let t1_words = []
    let t2_words = []
    let result = []
    
    t1 !== undefined && Object.values(t1).map((line, index) => {
        let res = []
        Object.keys(line).map(k => k !== "id" ? res = res + t1[index][k] : "")
        t1_words[index] = res
        return (res)
    })

    // generate a "word" foreach line in t2
    t2 !== undefined && Object.values(t2).map((line, index) => {
        let res = []
        //Object.keys(line).map(key => res = (key !== "id" ? res + t2[index][key] : res))
        Object.keys(line).map(k => k !== "id" ? res = res + t2[index][k] : "" )
        t2_words[index] = res
        return (res)
    })

    t1_words.map((word, index) => result[index] = t2_words.indexOf(word)<0? false : true)

    return result
}

export const display_balance = (cpt) => {
      let expenses = calcIncomeSum(cpt['family_expenses'],'expense_sum'),
          debts    = calcIncomeSum(cpt['family_debts'],'family_debt_monthlyreturn'),
          mort     = calcIncomeSum(cpt['family_mortgage'],'mortgage_monthly'),
          income   = calcTotalIncome(cpt['family_income'],'income_sum','income_frequency'),
          savings  = parseInt(cpt['family_savings']['monthly_savings_avg'])
      let balance = parseInt(income) - (parseInt(expenses)+parseInt(debts)+parseInt(mort)+parseInt(savings))
      let debts_percent = debts > 0 ? Math.round(debts/income*100) : 0
      let mort_percent = mort > 0 ? Math.round(mort/income*100) : 0
      let total_expenses = debts + mort + expenses + savings
      let diffColor = (value) => value < 0 ? {color:'red'} : {color:'green'}

    return(
        <div className="display-balance">
            <div className="table-total">
                <span className="table-total-title">פער הכנסות מול הוצאות: </span>
                <span className="table-sum" style={diffColor(balance)}>{balance.toLocaleString('he-IL')}</span>
            </div>
            <div className="table-total">
                <span className="table-total-title">סה"כ הכנסות חודשי </span>
                <span className="table-sum" style={diffColor(income)}>{income.toLocaleString('he-IL')}</span>
            </div>
            <IncomeDetails products={cpt['family_income']} />
            <div className="table-total">
                <span className="table-total-title">סה"כ הוצאות והחזרים </span>
                <span className="table-sum">{total_expenses.toLocaleString('he-IL')}</span>
            </div>
            <ul className="sub-sum">
                <li>
                    <SumTable className="sub-sum" products={cpt['family_expenses']} field={'expense_sum'} title={'סה"כ הוצאות חודשי'} />
                </li>
                <li>
                    <SumTable className="sub-sum" products={cpt['family_debts']} field={'family_debt_monthlyreturn'} title={'החזר חובות חודשי'} />
                    { debts <= 0 ? null : income <= 0 ? <span className="table-total">אין הכנסות!</span> :
                        debts_percent > 0 ? <span className="table-total">&nbsp;({debts_percent}% מההכנסות)</span> : null}
                </li>
                <li>
                    <SumTable className="sub-sum" products={cpt['family_mortgage']} field={'mortgage_monthly'} title={'משכנתאות החזר חודשי'} />
                    { mort <= 0 ? null : income <= 0 ? <span className="table-total">אין הכנסות!</span> : 
                        mort_percent > 0 ? <span className="table-total">&nbsp;({mort_percent}% מההכנסות)</span> : null}
                </li>
                <li>
                    <div className="table-total">
                        <span className="table-total-title">חסכון לילדים </span>
                        <span className="table-sum">{savings.toLocaleString('he-IL')}</span>
                    </div>
                </li>
            </ul>
        </div>

        )
}
export const compare_balance = (dfrom, dto, snap) => {
    return (
        <table>
            <tbody>           
            <tr><td><h5>{snap['from']}</h5></td><td><h5>{snap['to']}</h5></td></tr>
            <tr><td>{display_balance(dfrom)}</td><td>{display_balance(dto)}</td></tr>
            </tbody>
        </table>
    )
}